<h1 mat-dialog-title>{{ 'common.reportType.title' | translate }}</h1>
<form>

  <mat-accordion class="air-theme">
    @if (!data.isForAutomaticSign) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'common.reportType.options.reviewBy.label' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'common.reportType.options.reviewBy.label' | translate }}</mat-label>
          <mat-select [(ngModel)]="reportConfig.reviewBy" [ngModelOptions]="{standalone: true}">
            <mat-option>--</mat-option>
            @for (item of respDocs; track item) {
              <mat-option [value]="item.username">
                {{item.fullName}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-expansion-panel>
    }

    <mat-expansion-panel (opened)="onSelectRows()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'common.reportType.options.dataToInclude.label' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      @for (area of data.execution.areas; track area; let indexArea = $index) {
        <div>
          <mat-checkbox (change)="onAreaSelectChange(area, $event)" [checked]="isAreaSelected(area)">
            {{ area.name }}
          </mat-checkbox>
          @for (equipment of area.equipments; track equipment; let indexEquipment = $index) {
            <div>
              <mat-checkbox (change)="onEquipmentSelectChange(equipment, $event)" [checked]="isEquipmentSelected(equipment)"
                style="margin-left: 1em;">
                {{ showEquipment(equipment) }}
              </mat-checkbox>
            </div>
          }
          @for (room of area.rooms; track room; let indexRoom = $index) {
            <div>
              <mat-checkbox (change)="onRoomSelectChange(room, $event)" [checked]="isRoomSelected(room)"
                style="margin-left: 1em;">
                {{ room.name }}
              </mat-checkbox>
            </div>
          }
          @for (gas of area.compressedGases; track gas; let indexGas = $index) {
            <div>
              <mat-checkbox (change)="onCompressedGasSelectChange(gas, $event)" [checked]="isCompressedGasSelected(gas)"
                style="margin-left: 1em;">
                {{ gas.code }}
              </mat-checkbox>
            </div>
          }
        </div>
      }

    </mat-expansion-panel>

    <!--<mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'common.reportType.options.language.label' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (showChangeLangIcon() && !data.isForAutomaticSign) {
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'common.reportType.options.language.label' | translate }}</mat-label>
          <mat-select [(ngModel)]="reportConfig.lang" [ngModelOptions]="{standalone: true}">
            @for (item of langs; track item) {
              <mat-option [value]="item.lang">
                <mat-icon svgIcon="{{item.flag}}"></mat-icon>
                {{item.fullLang}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

    </mat-expansion-panel>-->

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'common.reportType.options.observations' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-checkbox name="changeObservations" [ngModel]="changeObservations"
        (change)="onChangeObservationsCheck($event)">
        {{'common.reportType.options.observations.label' | translate }}
      </mat-checkbox>

      @if (changeObservations) {
        <button mat-icon-button (click)="reloadObservations()" matTooltip="{{ 'button.reload' | translate }}"
          >
          <mat-icon>refresh</mat-icon>
        </button>
      }

      @if (changeObservations) {
        <div>
          <br />
          <mat-label>{{ 'common.reportType.options.observations.field' | translate }}</mat-label>
          <textarea matInput name="observations" style="resize: none;" [(ngModel)]="reportConfig.observations" rows="10"
          matAutosizeMinRows="10" style="resize: none;" required> </textarea>
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'common.reportType.options.deviations' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-checkbox name="changeDeviations" [ngModel]="changeDeviations" (change)="onChangeDeviationsCheck($event)">
        {{'common.reportType.options.deviations.label' | translate }}
      </mat-checkbox>

      @if (changeDeviations) {
        <button mat-icon-button (click)="reloadDeviations()" matTooltip="{{ 'button.reload' | translate }}"
          >
          <mat-icon>refresh</mat-icon>
        </button>
      }

      @if (changeDeviations) {
        <div>
          <br />
          <mat-label>{{ 'common.reportType.options.deviations.field' | translate }}</mat-label>
          <textarea matInput name="deviations" style="resize: none;" [(ngModel)]="reportConfig.deviations"
            rows="10" matAutosizeMinRows="10"
          style="resize: none;" required> </textarea>
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'common.reportType.options.conclusions' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-checkbox name="changeConclusions" [ngModel]="changeConclusions" (change)="onChangeConclusionsCheck($event)">
        {{'common.reportType.options.conclusions.label' | translate }}
      </mat-checkbox>

      @if (changeConclusions) {
        <button mat-icon-button (click)="reloadConclusions()" matTooltip="{{ 'button.reload' | translate }}"
          >
          <mat-icon>refresh</mat-icon>
        </button>
      }

      @if (changeConclusions) {
        <div>
          <br />
          <mat-label>{{ 'common.reportType.options.conclusions.field' | translate }}</mat-label>
          <textarea matInput name="conclusions" style="resize: none;" [(ngModel)]="reportConfig.conclusions" rows="10"
          matAutosizeMinRows="10" style="resize: none;" required> </textarea>
        </div>
      }
    </mat-expansion-panel>

  </mat-accordion>

  <br /><br />

  <div mat-dialog-actions class="air-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>
    {{ 'button.download' | translate }}</button>
    <!--<button mat-raised-button color="primary" (click)="onOkClick(true)"
    cdkFocusInitial>{{ 'button.download.hybride' | translate }}</button>-->
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>